import { Injectable } from '@angular/core';
import { LocalStorageKeys } from '../core/enums/LocalStorageKeys';
import { AuthenticationResult } from '@azure/msal-browser';


@Injectable({
  providedIn: 'root'
})
export class TokenService {

  getAccessToken(): string | null {
    return localStorage.getItem(LocalStorageKeys.AccessToken);
  }

  getExpiresOn(): number | null {
    const v = localStorage.getItem(LocalStorageKeys.TokenExpiration);
    return v ? +v : null;
  }

  isTokenValid(bufferMs = 60_000): boolean {
    const expiresOn = this.getExpiresOn();
    return !!expiresOn && Date.now() + bufferMs < expiresOn;
  }

  persist(result: AuthenticationResult) {
    localStorage.setItem(LocalStorageKeys.AccessToken, result.accessToken);
    localStorage.setItem(LocalStorageKeys.TokenExpiration, result.expiresOn?.getTime().toString() ?? '');
  }

  clear() {
    localStorage.removeItem(LocalStorageKeys.AccessToken);
    localStorage.removeItem(LocalStorageKeys.TokenExpiration);
  }
}
